import styled from '@emotion/styled'
import TextareaAutosize from 'react-textarea-autosize'

import { colors, spacing } from '../constants'
import { Text } from '../typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTextareaAutosize = styled(Text.withComponent(TextareaAutosize))`
  border: 1px solid ${colors.border.default};
  border-radius: 3px;
  margin-top: ${spacing.majorScale(1)}px;
  padding: ${spacing.majorScale(2)}px;

  &:focus {
    outline: none;

    border-color: ${colors.border.active};
  }

  &[aria-invalid='true'] {
    border-color: ${colors.border.error};
  }

  &::placeholder {
    color: ${colors.text.hint};
  }

  &:disabled {
    border-color: ${colors.border.disabled};

    &::placeholder {
      color: ${colors.text.disabled};
    }
  }
`

export const ValidationHint = styled(Text)`
  color: ${colors.text.error};
  margin-top: ${spacing.majorScale(1)}px;
`
